import React from "react";
import { CardContent, Fade } from "@material-ui/core";
import { CardPageItem } from "../../custom/Page";

const AnimatedCardContent = ({
  children,
  show = true,
  raised = true,
  double,
  divStyle = { width: "100%" },
  margin
}) => {
  return (
    <Fade
      in={show}
      mountOnEnter
    >
      <CardPageItem
        raised={raised}
        double={double}
        margin={margin}
      >
        <CardContent>{children}</CardContent>
      </CardPageItem>
    </Fade>
  );
};

export default AnimatedCardContent;
